import { render, staticRenderFns } from "./FaceValidate.vue?vue&type=template&id=0c942d36&"
import script from "./FaceValidate.vue?vue&type=script&lang=js&"
export * from "./FaceValidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports